/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import * as ROOM_NAMES from "../rooms/RoomNameConstants";
import ExploreRoom from "../rooms/ExploreRoom/ExploreRoom";
import JobRoom from "../rooms/JobRoom/JobRoom";
import HomeRoom from "../rooms/HomeRoom/HomeRoom";
import TopologyRoom from "../rooms/TopologyRoom/TopologyRoom";
import DelayAnalysisRoom from "../rooms/DelayAnalysisRoom/DelayAnalysisRoom";
import WorkstationRoom from "../rooms/WorkstationRoom/WorkstationRoom";

export const getRoomFromID = (ID) => {
    switch (ID) {
        case ROOM_NAMES.JOB_ROOM:
            return JobRoom;
        case ROOM_NAMES.EXPLORE_ROOM:
            return ExploreRoom;
        case ROOM_NAMES.DELAY_ANALISYS_ROOM:
            return DelayAnalysisRoom;
        case ROOM_NAMES.TOPOLOGY_ROOM:
            return TopologyRoom;
        case ROOM_NAMES.WORKSTATION_ROOM:
            return WorkstationRoom;
        case ROOM_NAMES.HOME_ROOM:
        default:
            return HomeRoom;
    }
};
